import api from '../httpClient';

export type ProgramSurveyAnswer = number | string | string[];
export type ProgramSurveyStatus = 'available' | 'submitted' | 'upcoming' | 'closed';

export interface ProgramSurveySummary {
  id: string;
  title: string;
  occasion: string;
  opens_at: string;
  closes_at: string;
  status: ProgramSurveyStatus;
  engagement_name: string;
  session_title?: string | null;
  version: number;
}

export interface ProgramSurveyItem {
  id: string;
  label: string;
  type: 'rating' | 'choice' | 'text';
  min?: number;
  max?: number;
  max_length?: number;
  options?: Array<{ value: string; label: string }>;
  required: boolean;
  min_label?: string;
  max_label?: string;
}

export interface ProgramSurveyResponse {
  answers: Record<string, ProgramSurveyAnswer>;
  version: number;
  submitted_at: string | null;
}

export interface ProgramSurveyDetail extends ProgramSurveySummary {
  items: ProgramSurveyItem[];
  response: ProgramSurveyResponse | null;
  privacy_notice: string;
}

export interface SaveProgramSurvey {
  request_id: string;
  expected_version: number;
  answers: Record<string, ProgramSurveyAnswer>;
  submit: boolean;
}

export const engagementSurveys = {
  list: async (): Promise<ProgramSurveySummary[]> => (
    await api.get<{ surveys: ProgramSurveySummary[] }>('/api/engagement-surveys/')
  ).data.surveys,
  get: async (id: string): Promise<ProgramSurveyDetail> => (
    await api.get<ProgramSurveyDetail>(`/api/engagement-surveys/${encodeURIComponent(id)}/`)
  ).data,
  save: async (id: string, payload: SaveProgramSurvey): Promise<ProgramSurveyResponse> => (
    await api.post<ProgramSurveyResponse>(`/api/engagement-surveys/${encodeURIComponent(id)}/`, payload)
  ).data,
};
